import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import { Box, CircularProgress, IconButton, Stack, Typography } from '@mui/material';
import SearchRfcIcon from 'assets/icons/line-assigments/add-line.svg';

export const LinesList = ({ lines = [], onDeleteLine, formatPhoneNumber, loading }) => {
  if (loading) {
    return (
      <Box
        height={'28rem'}
        alignContent={'center'}
        display={'flex'}
        justifyContent={'center'}
        alignItems={'center'}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      {lines.length > 0 ? (
        <Box
          sx={{
            width: '100%',
            border: '1px solid #ECEAF4',
            borderRadius: 4,
            backgroundColor: '#fff',
            boxShadow: '0 8px 24px rgba(44, 32, 82, 0.06)',
            p: 2.5,
          }}
        >
          <Stack direction='row' spacing={1.5} sx={{ overflowX: 'auto', pb: 0.5 }}>
            {lines.map((line, index) => (
              <Box
                key={`${line}-${index}`}
                sx={{
                  minWidth: { xs: 260, sm: 280 },
                  flex: '0 0 auto',
                  height: 72,
                  borderRadius: 3,
                  backgroundColor: '#F8F7FB',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  px: 2,
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0, gap: 1.5 }}>
                  <Box
                    sx={{
                      width: 38,
                      height: 38,
                      borderRadius: '50%',
                      backgroundColor: '#ECE8F9',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                    }}
                  >
                    <PhoneAndroidIcon sx={{ fontSize: 20, color: '#776EA2' }} />
                  </Box>

                  <Typography
                    sx={{
                      fontSize: 16,
                      fontWeight: 600,
                      color: '#3B3846',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {formatPhoneNumber(line)}
                  </Typography>
                </Box>

                <IconButton
                  aria-label='Eliminar línea'
                  onClick={() => onDeleteLine?.(line)}
                  sx={{ color: '#5C5C66', flexShrink: 0 }}
                >
                  <DeleteOutlineOutlinedIcon />
                </IconButton>
              </Box>
            ))}
          </Stack>
        </Box>
      ) : (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            py: 4,
            mt: 8,
          }}
        >
          {/* Icono */}
          <Box
            component='img'
            src={SearchRfcIcon}
            alt='Sin líneas vinculadas'
            sx={{ display: 'block', mx: 'auto', mb: 2 }}
            width={48}
            height={48}
          />

          <Typography
            gutterBottom
            sx={{ fontSize: 14, color: '#b3b3b3', fontWeight: 400 }}
            textAlign={'center'}
          >
            Agrega una línea para vincularla
          </Typography>
        </Box>
      )}
    </>
  );
};
